import { Drawer, Space } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { RevxButton } from 'components/RevxButton';
import RevxTable, { TableColumnsType } from 'components/RevxTable';
import { SvcSpec } from 'domains/svcDomain';
import { isEmpty, isUndefined } from 'lodash-es';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const SVCSpecBaseSelect = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { visible, orgSvc } = useAppSelector(
    (state) => state.svc.specBaseSelectState
  );

  useEffect(() => {
    dispatch.svc.getAllBaseSVCs();
  }, [dispatch.svc]);

  const loading = useAppSelector(
    (state) => state.loading.effects.svc.getAllBaseSVCs
  );

  const baseSvcList = useAppSelector((state) => state.svc.baseSelectState.data);
  const baseSpecList: SvcSpec[] = useMemo(() => {
    if (isUndefined(orgSvc)) return [];
    if (isUndefined(baseSvcList) || isEmpty(baseSvcList)) return [];
    return (
      baseSvcList
        .find((baseSvc) => baseSvc.revxId === orgSvc.revxId)
        ?.svcSpecs.filter(
          (baseSpec) =>
            orgSvc.svcSpecs.findIndex(
              (orgSpec) => orgSpec.revxId === baseSpec.revxId
            ) < 0
        ) || []
    );
  }, [baseSvcList, orgSvc]);

  const onClose = () => {
    dispatch.svc.setOrgSvc(undefined);
    dispatch.svc.updateSpecBaseSelectVisible(false);
  };

  const specColumns: TableColumnsType<SvcSpec> = [
    {
      title: t('common.revxId'),
      dataIndex: 'revxId',
      width: 80,
    },
    {
      title: t('common.description'),
      dataIndex: 'description',
      width: 80,
    },
    {
      title: t('platform.svc.tableColumn.costUsd'),
      width: 80,
      dataIndex: 'costUsd',
      valueType: 'money',
      decimalDigits: 4,
      responsive: ['xl'],
    },
    {
      title: t('platform.svc.tableColumn.makereadyCost'),
      width: 80,
      dataIndex: 'makereadyCostUsd',
      valueType: 'money',
      decimalDigits: 2,
      responsive: ['xl'],
    },
    {
      title: t('common.actions'),
      key: 'actions',
      width: 80,
      render: (value, record) => (
        <Space size="small">
          <RevxButton
            type="link"
            key="view"
            size="small"
            onClick={() => {
              dispatch.svc.addSpec({
                baseSpecId: record.id,
                orgSvcId: orgSvc!.id,
              });
              onClose();
            }}
          >
            {t('platform.svc.baseSelect.select')}
          </RevxButton>
        </Space>
      ),
    },
  ];

  return (
    <Drawer
      title={t('platform.svc.form.title.addSpec')}
      placement="right"
      width={800}
      bodyStyle={{ paddingTop: 0 }}
      closable={true}
      onClose={onClose}
      visible={visible}
    >
      <RevxTable<SvcSpec>
        loading={loading}
        size="small"
        pagination={false}
        columns={[...specColumns]}
        scroll={undefined}
        dataSource={baseSpecList}
        rowKey={(record) => 'spec' + record.id}
      />
    </Drawer>
  );
};
